export default "__VITE_ASSET__DTLN3uAS__"